export var ViewType;
(function (ViewType) {
    ViewType["Grid"] = "grid";
    ViewType["Table"] = "table";
    ViewType["Combo"] = "combo";
})(ViewType || (ViewType = {}));
export const VIEW_TYPE_GRID = ViewType.Grid;
export const VIEW_TYPE_TABLE = ViewType.Table;
export const VIEW_TYPE_COMBO = ViewType.Combo;
